module.exports = __webpack_public_path__ + "media/images/task_list_empty_state-2e9add87ea4bbfbe53b84ef9d2b20371.svg";